import {
  useCallback,
} from 'react';
import {
  Outlet,
  Navigate,
  useLocation,
} from 'react-router';
import {
  useSelector,
  useDispatch,
} from 'react-redux';

import {
  coreActions,
  coreSelectors,
} from '@gymcloud/core';

import {
  Spinner,
  NotFound,
} from 'web-components';

import {
  MainHeader,
  MainSidebar,
} from 'web-containers';

import {
  getNamespaceSymbol,
} from 'web-utils'

import Modals from './Modals';
import * as S from './styled';

const getLoginUrl = (): string => {
  const namespaceSymbol = getNamespaceSymbol() || 'gymcloud'

  const shouldSuggestApp = window.matchMedia('(max-width: 768px)').matches &&
    /iPhone|iPod|Android/i.test(navigator.userAgent)

  if (!shouldSuggestApp) return '/login'
  return namespaceSymbol === 'strongfirst' ? '/login' : '/get_app'
}

const MainLayout = () => {
  const location = useLocation();
  const mapState = useCallback(state => ({
    profile: coreSelectors.getProfile(state),
  }), []);
  const { profile } = useSelector(mapState);
  const dispatch = useDispatch();

  const {
    isAuth,
    isLoading,
    dashboard,
  } = profile;

  const failed = (!isLoading && !isAuth);
  const success = !isLoading && isAuth;

  if (!profile.hasToken) return <Navigate to={getLoginUrl()} state={{ from: location }} replace />;

  const hasAannouncement = dashboard?.announcement;

  return (
    <>
      {hasAannouncement && hasAannouncement?.pro_id !== profile.id && (
        <S.Announcement>
          <S.AnnouncementTitle>{dashboard.announcement.title}</S.AnnouncementTitle>
          <S.AnnouncementDescription>
            {dashboard.announcement.description}
          </S.AnnouncementDescription>
          <S.AnnouncementDismiss
            onClick={() => {
              dispatch(
                coreActions.requestDismissAnnouncement({
                  id: dashboard.announcement.id,
                }),
              );
            }}
          >
            Dismiss
          </S.AnnouncementDismiss>
        </S.Announcement>
      )}

      {success && (
        <S.Layout>
          <MainSidebar />
          <S.Main id="main">
            <MainHeader
              profile={profile}
            />
            <S.Content id="content">
              <Outlet />
            </S.Content>
          </S.Main>

          {/* Global Modals */}
          <Modals />
        </S.Layout>
      )}

      {isLoading && (
        <Spinner />
      )}

      {failed && (
        <NotFound title="Loading failed" />
      )}
    </>
  );
};

export default MainLayout;
